export const environment = {
  production: true,
  connection: {
    name: 'ABAU Testsystem',
    host: 'https://portal-test.abau.at',
    port: 443,
    basePath: '/api',
  },
};
